let DataTables = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.newSubscriptionsThisWeek();
        this.cancelledSubscriptionsThisWeek();
        this.trackPlays();
        this.reports();
        this.daysIntense();
        this.fcmNotifications();
        this.products();
        this.groups();
        this.offices();
        this.teams();
        this.teamsMembers();
        this.carts();
        this.contactFormSubmissions();
        this.newsletterOptins();
        this.playlists();
        this.landingPages();
        this.albumCategories();
        this.albums();
        this.resourceTypes();
        this.resourceCategories();
        this.resources();
        this.qrCodes();
        this.jotforms();
        this.shortUrls();
        this.forms();
        this.formSubmissions();
        this.users();
    },

    newSubscriptionsThisWeek: function () {
        let table = $('#newSubscriptionsThisWeek');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'new-subscriptions-this-week',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'new-subscriptions-this-week',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ]
            });
        }
    },

    cancelledSubscriptionsThisWeek: function () {
        let table = $('#cancelledSubscriptionsThisWeek');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'cancelled-subscriptions-this-week',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'cancelled-subscriptions-this-week',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ]
            });
        }
    },

    trackPlays: function () {
        let table = $('#trackPlays');

        if (table.length) {
            table.dataTable({
                serverSide: true,
                ajax: '/tracks/json',
                searching: true,
                sort: false,
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {extend: 'csv', title: 'track-plays', className: 'btn-sm'},
                    {extend: 'pdf', title: 'track-plays', className: 'btn-sm'},
                    {extend: 'print', className: 'btn-sm'}
                ]
            });
        }
    },

    reports: function (type, group) {
        let table = $('#reports');
        let order = 2;
        if (type == 'albums') {
            order = 1;
        } else if (type == 'group-by' && group == 'source') {
            order = 1;
        }

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {extend: 'csv', title: 'track-plays', className: 'btn-sm'},
                    {extend: 'pdf', title: 'track-plays', className: 'btn-sm'},
                    {extend: 'print', className: 'btn-sm'}
                ],
                order: [[order, 'desc']]
            });
        }
    },

    daysIntense: function () {
        let table = $('#daysIntense');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {extend: 'csv', title: 'days-intense', className: 'btn-sm'},
                    {extend: 'pdf', title: 'days-intense', className: 'btn-sm'},
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 2, iDataSort: 3},
                    {targets: 3, visible: false},
                    {targets: 4, iDataSort: 5},
                    {targets: 5, visible: false},
                    {targets: 8, sortable: false},
                ]
            });
        }
    },

    fcmNotifications: function () {
        let table = $('#fcmNotifications');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 3, iDataSort: 4},
                    {targets: 4, visible: false},
                ],
                order: [[3, 'desc']]
            });
        }
    },

    products: function () {
        let table = $('#products');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 15, visible: false},
                    {targets: 14, sortable: false},
                ],
                order: [[15, 'desc']]
            });
        }
    },

    groups: function () {
        let table = $('#groups');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 8, sortable: false},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    offices: function () {
        let table = $('#offices');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 4, sortable: false},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    teams: function () {
        let table = $('#teams');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 3, sortable: false},
                ],
                order: [[0, 'asc']],
                initComplete: function () {
                    this.api()
                        .columns()
                        .every(function () {
                            let column = this;
                            if (column.header().innerText === 'Active') {
                                let select = $('<label class="m-l">Active: <select class="form-control"><option value="">All</option></select></label>')
                                    .appendTo($('#teams_filter'));

                                    select.find('select').on('change', function () {
                                        let val = $.fn.dataTable.util.escapeRegex($(this).val());

                                        column.search(val ? '^' + val + '$' : '', true, false).draw();
                                    });

                                select.find('select').append('<option value="Yes">Active</option>');
                                select.find('select').append('<option value="No">Inactive</option>');
                            }
                        });
                },
            });
        }
    },

    teamsMembers: function () {
        let table = $('#teamMembers');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 3, sortable: false},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    carts: function () {
        let table = $('#carts');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, iDataSort: 1},
                    {targets: 1, visible: false},
                    {targets: 9, sortable: false},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    contactFormSubmissions: function () {
        let table = $('#contactFormSubmissions');

        if (table.length) {
            table.dataTable({
                serverSide: true,
                processing: true,
                ajax: '/form-submissions/contact-form-json',
                searching: true,
                sort: false,
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[5, 10, 25, 50, 100, 150, 200, 250, -1], [5, 10, 25, 50, 100, 150, 200, 250, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'contact-form-submissions',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'contact-form-submissions',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    // {targets: 10, iDataSort: 11},
                    // {targets: 11, visible: false},
                ],
                order: [[10, 'desc']],
            });

            table.on('draw.dt', function () {
                window.Init.tooltip();
            });
        }
    },

    newsletterOptins() {
        let table = $('#newsletterOptins');

        if (table.length) {
            table.dataTable({
                serverSide: true,
                ajax: '/form-submissions/newsletter-optins-json',
                searching: false,
                sort: false,
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[5, 10, 25, 50, 100, 150, 200, 250, -1], [5, 10, 25, 50, 100, 150, 200, 250, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'newsletter-optins',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'newsletter-optins',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    // {targets: 15, iDataSort: 16},
                    // {targets: 16, visible: false},
                    // {targets: 17, sortable: false},
                ],
                // order: [[10, 'desc']]
            });
        }
    },

    landingPages() {
        let table = $('#landingPages');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 5, sortable: false},
                    {targets: 3, iDataSort: 4},
                    {targets: 4, visible: false},
                ],
                order: [[3, 'desc']]
            });
        }
    },

    playlists() {
        let table = $('#playlists');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, sortable: false},
                    {targets: 1, sortable: false},
                    {targets: 2, visible: false},
                    {targets: 3, sortable: false},
                ],
                order: [[2, 'asc']]
            });
        }
    },

    albumCategories() {
        let table = $('#albumCategories');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-3'l>'<'col-sm-3 row toolbar'><'col-sm-3 text-center'B><'col-sm-3'f>><'row'<'col-sm-12'tp>>",
                "lengthMenu": [[25, 50, -1], [25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, sortable: false},
                    {targets: 1, sortable: false},
                    {targets: 2, visible: false},
                    {targets: 3, sortable: false},
                    {targets: 4, visible: false},
                ],
                order: [[2, 'asc']]
            });
        }
    },

    albums() {
        let table = $('#albums');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, visible: false},
                    {targets: 1, sortable: false},
                ],
                order: [[0, 'asc']],
            });
        }

    },

    resourceTypes() {
        let table = $('#resourceTypes');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[25, 50, -1], [25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, sortable: true},
                    {targets: 1, sortable: false},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    resourceCategories() {
        let table = $('#resourceCategories');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[25, 50, -1], [25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, sortable: true},
                    {targets: 1, sortable: false},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    resources() {
        let table = $('#resources');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[25, 50, -1], [25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, sortable: true},
                    {targets: 1, sortable: false},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    qrCodes() {
        let table = $('#qrCodesTable');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[25, 50, -1], [25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, sortable: true},
                    {targets: 1, sortable: false},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    jotforms() {
        let table = $('#jotformsTable');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[25, 50, -1], [25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, sortable: true},
                    {targets: 1, sortable: false},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    shortUrls() {
        let table = $('#shortUrlsTable');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[25, 50, -1], [25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, sortable: true},
                    {targets: 1, sortable: true},
                    {targets: 2, sortable: true},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    forms() {
        let table = $('#formsTable');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[25, 50, -1], [25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 0, sortable: true},
                    {targets: 1, sortable: true},
                    {targets: 2, sortable: true},
                ],
                order: [[0, 'asc']]
            });
        }
    },

    formSubmissions() {
        let table = $('#formSubmissions');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                order: [[0, 'asc']],
            });
        }

    },

    users () {
        let table = $('#users');

        if (table.length) {
            table.dataTable({
                dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                buttons: [
                    {extend: 'copy', className: 'btn-sm'},
                    {
                        extend: 'csv',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {
                        extend: 'pdf',
                        title: 'fcm-notifications',
                        className: 'btn-sm'
                    },
                    {extend: 'print', className: 'btn-sm'}
                ],
                columnDefs: [
                    {targets: 2, visible: false},
                    {targets: 3, sortable: false},
                ],
                order: [[2, 'desc']],
            });
        }
    },
};

$().ready(function () {
    window.DataTables = DataTables;
    window.DataTables.init();
});
